import {MySongsPageSortColumnType} from "../../../config/my-songs-page-sort";
import {useAppSelector} from "../../../redux/hooks";
import {mySongsPageStore} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";

export interface IFilterSortColumnsLogic {
  value: MySongsPageSortColumnType;
  onChangeHandler: (newValue: MySongsPageSortColumnType) => void;
}

export const useFilterSortColumnsLogic = (): IFilterSortColumnsLogic => {
  return {
    value: useAppSelector(mySongsPageStore.getSortColumn),
    onChangeHandler: (sortColumn: MySongsPageSortColumnType) => mySongsPageStore.setSortColumn(sortColumn),
  };
}
